/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";

export default function Footer() {
    const { user } = useUser()

    return <footer>
        <section className="footer-social">
            <div className="container">
                <div className="row  fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                    <div className="col-lg-12">
                        <h2 className="text-center">Get Connected</h2>
                    </div>
                </div>
                <div className="row  fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                    <div className="col-xl-4 col-6">
                        <a className="loop-social d-block" href="ссылкатг" target="_blank" rel="noreferrer">
                            <div className="icon">
                                <div className="inner">
                                    <img alt="" src="/img/ic-telegram.svg" />
                                </div>
                            </div>
                            <div className="desc">
                                <h5>Telegram</h5>
                            </div>
                        </a>
                    </div>


                    <div className="col-xl-4 col-6">
                        <a className="loop-social d-block" href="ссылкатг2" target="_blank" rel="noreferrer">
                            <div className="icon">
                                <div className="inner">
                                    <img alt="" src="/img/ic-announcement.svg" />
                                </div>
                            </div>
                            <div className="desc">
                                <h5>Announcement</h5>
                            </div>
                        </a>
                    </div>

                    <div className="col-xl-4 col-6">
                        <a className="loop-social d-block" href="https://twitter.com/IOST_Official" target="_blank" rel="noreferrer">
                            <div className="icon">
                                <div className="inner">
                                    <img alt="" src="/img/ic-twitter.svg" />
                                </div>
                            </div>
                            <div className="desc">
                                <h5>Twitter</h5>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-4 col-6">
                        <a className="loop-social d-block" href="https://www.facebook.com/IOSTofficial" target="_blank" rel="noreferrer">
                            <div className="icon">
                                <div className="inner">
                                    <img alt="" src="/img/ic-facebook.svg" />
                                </div>
                            </div>
                            <div className="desc">
                                <h5>Facebook</h5>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-4 col-6">
                        <a className="loop-social d-block" href="https://www.linkedin.com/company/iostproject/" target="_blank" rel="noreferrer">
                            <div className="icon">
                                <div className="inner">
                                    <img alt="" src="/img/ic-linkedin.svg" />
                                </div>
                            </div>
                            <div className="desc">
                                <h5>LinkedIn</h5>
                            </div>
                        </a>
                    </div>

                    <div className="col-xl-4 col-6">
                        <a className="loop-social d-block" href="http://medium.com/iost" target="_blank" rel="noreferrer">
                            <div className="icon">
                                <div className="inner">
                                    <img alt="" src="/img/ic-medium.svg" />
                                </div>
                            </div>
                            <div className="desc">
                                <h5>Medium</h5>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="footer-nav">
            <div className="container">
                <div className="row  fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                    <div className="col-lg-2">
                        <div className="item">
                            <h6>
                                Get Started
                            </h6>
                            <ul>
                                <li>
                                    <Link to="/terms" target="_blank" rel="noreferrer">Terms of Use</Link>
                                </li>
                                {user ?
                                    <li>
                                        <Link to="/dashboard">Wallet</Link>
                                    </li>
                                    : <>
                                        <li>
                                            <Link to="/login">Login</Link>
                                        </li>
                                        <li>
                                            <Link to="/register">Register</Link>
                                        </li>
                                    </>}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-10">
                        <div className="item">
                            <h6>
                                Description
                            </h6>
                            <p>
                                IOST Wallet is an institution-grade, digital asset wallet for professionals. Combining robust security protocols, intuitive user interface, and multi-chain support, IOST Wallet allows you to enjoy the best features of cold and hot wallets.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="footer-copyright">
            <div className="container">

                <div className="row">
                    <div className="col-lg-12">
                        <p>This website does not provide service for the countries where crypto currency are prohibited.</p>
                        <p>© 2022 - 2025 IOS Foundation <Link to="/terms">Privacy Policy · Terms of Use</Link></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
}